import config from "../../../config.json";

export default {
    namespaced: true,

    state: {
        atendimento: {
            protocolo: null,
            messages: [],
            ultimoAgente: null
        },
        user: {},
    },
    mutations: {
        setState(state) {
            if (state.protocolo !== null) {
                if (localStorage.getItem('state')) {
                    localStorage.removeItem('state');
                    localStorage.setItem('state', JSON.stringify(state));

                } else {
                    localStorage.setItem('state', JSON.stringify(state));
                }
            }

        },
        getState(state) {
            if (localStorage.getItem('state')) {
                console.log('local', localStorage.getItem('state'))
                let local = JSON.parse(localStorage.getItem('state'));
                state.user = local.user;
                state.atendimento = local.atendimento
                console.log('GET', state)
            }

        },
        removeState(state) {
            state.atendimento = {
                protocolo: null,
                messages: [],
                ultimoAgente: null
            }
        },
        ws_connect(state) {
            let data = {};
            if (state.user.uid) {
                data.clientID = config.clientID;
                data.id = this._vm.$socket.id;
                data.protocolo = state.atendimento.protocolo;
                data.uid = state.user.uid;
                data.instanceID = state.user.tipo;
                data.token = 'teste';
                data.ativo = 1;
                data.from = state.user.uid;
                data.nome = 'site';
                data.inOut = 1;
                data.name = state.user.nome;
                data.queueTypeID = 2;
                data.action = "webChat";
                this._vm.$socket.emit('LoginChat', data);
            }
        },
        ws_authenticated(state, data) {
            console.log(data);
        },
        ws_sendMsgFile(state, data) {
            try {
                console.log(state.atendimento);
                console.log('SENDMSGFILE', data)
                state.atendimento.messages.push({
                    type: 'you',
                    text: data.legenda,
                    isFile:true,
                    path:data.file,
                    mimetype:data.mimetype,
                    date: new Date()
                });
            } catch (error) {
                console.error(error)
            }
        },
        ws_sendMsg(state, data) {
            try {
                console.log('newMsg', data)
                if (!state.messages) state.messages = [];
                if (data.event === 'EncerrarAtendimento') {
                    state.atendimento.lastEvent = 'EncerrarAtendimento';
                    
                    state.atendimento.messages.push({
                        type: data.msg.agente === 'xcontact' ? '' : 'you',
                        agente: data.msg.agente,
                        text: data.msg.texto.replace("$protocolo", data.protocolo),
                        id: data.msg.id,
                        isLink:data.msg.texto.includes("http")?true:false,
                        date: new Date()
                    });
                    console.log(data);
                    console.log(state.atendimento);
                    return;

                }

                if (data.protocolo) {
                    state.atendimento.protocolo = data.protocolo;
                }
                if (data.msg.texto.includes("http")) {   
                    console.log('TINHA')                
                    state.atendimento.messages.push({
                        type: data.msg.agente === 'xcontact' ? '' : 'you',
                        agente: data.msg.agente,
                        text: data.msg.texto,
                        isLink:true,
                        id: data.msg.id,
                        date: new Date()
                    });
                    return
                  }
                state.atendimento.messages.push({
                    type: data.msg.agente === 'xcontact' ? '' : 'you',
                    agente: data.msg.agente,
                    text: data.msg.texto.replace("$protocolo", data.protocolo),
                    id: data.msg.id,
                    date: new Date()
                });
            } catch (error) {
                console.error(error);
            }

        },
        ws_encerraAtendimento(state, data) {
            if (!state.messages) state.messages = [];
            data = JSON.parse(data);
            console.log('ENCERRA', data)
            if (data.protocolo) {
                state.atendimento.protocolo = data.protocolo;
            }
            state.atendimento.lastEvent = 'EncerrarAtendimento';
            if(data.Msg.includes("http")) {
                console.log('TINHA', data['Msg'])
                 state.atendimento.messages.push({
                    type: '',
                    isLink:true,
                    text: data['Msg'],
                    date: data.data_hora,
                })
                return
            }
            state.atendimento.messages.push({
                type: '',
                text: data['Msg'],
                date: data.data_hora,
            })
        },
        ws_message(state, data) {
            console.log('AQUI', data)
            if (!state.messages) state.messages = [];

            data = JSON.parse(data);
            if (data.protocolo) {
                state.atendimento.protocolo = data.protocolo;
            }
            if (data['event'] == 'QueueDisponivel') {
                state.messages.push({
                    type: '',
                    text: data['resposta'].replace("$protocolo", data.protocolo),
                    date: new Date()
                });
            }
            if (data['event'] == 'QueueIndisponivel') {
                state.atendimento.messages.push({
                    type: '',
                    text: data['resposta'].replace("$protocolo", data.protocolo),
                    date: data.data_hora
                })
                localStorage.setItem('messages', JSON.stringify(this.messages))
            }

            if (data.action == 'ClientChatMessage' && data.event !== 'EncerrarAtendimento') {                
                state.atendimento.messages.push({
                    type: 'you',
                    agente: data['agente'],
                    text: data['Msg'].replace(/<[^>]*>/g, ""),
                    date: data.data_hora,
                    file: { file: data.file, file_name: data.file_name }
                })
                state.atendimento.ultimoAgente = data.agente;
            }
            if (data.event === 'QueueSemAgentes') {
                state.atendimento.messages.push({
                    type: '',
                    text: data['resposta'],
                    date: new Date()
                });

            }
            if (data.event === 'EncerrarAtendimento') {
                state.atendimento.lastEvent = 'EncerrarAtendimento';

                state.atendimento.messages.push({
                    type: '',
                    text: data['Msg'],
                    date: data.data_hora,
                })
            }
            console.log(data);
            console.log(state.atendimento);
        },
        login(state, data) {
            state.user = data;
        },
        authenticate(state, data) {
            console.log(state.user);
            data.clientID = config.clientID;
            data.id = this._vm.$socket.id;
            data.uid = state.user.uid;
            data.instanceID = state.user.tipo;
            data.token = 'teste';
            data.ativo = 1;
            data.from = state.user.uid;
            data.nome = 'site';
            data.inOut = 1;
            data.name = state.user.nome;
            data.queueTypeID = 2;
            data.action = "webChat";
            console.log('auth', data);
            this._vm.$socket.emit('LoginChat', data);
        },
        sendMessage(state, dados) {
            let data = { ...state.user };
            data.queue = data.tipo;
            data.from = data.uid;
            data.name = data.nome;
            data.action = 'webChatMessage';
            data.dados_adicionais = { nome: data.nome, email: data.uid };
            data.data_hora = new Date();
            data.Msg = dados;
            data.clientID = config.clientID;
            data.xcontactID = config.clientID;
            this._vm.$socket.emit('sendMsgSite', data);
            state.atendimento.messages.push({
                type: 'me',
                text: data.Msg,
                date: data.data_hora
            })
        }
    },
    actions: {
        login({ commit }, data) {
            commit('login', data);
        },
        authenticate({ commit }, data) {
            commit('authenticate', data);
        },
        sendMessage({ commit }, data) {
            commit('sendMessage', data);
        },
        setState({ commit }) {
            console.log('vamos setar no localstorage');
            commit('setState');
        },
        getState({ commit }) {
            commit('getState');
        },
        removeState({ commit }) {
            commit('removeState');
        }
    }
}